/**
 * Builds the object returned from useFlowchartCore (single place for the public surface area).
 */
export function gatherFlowchartCorePublicApi({
  base,
  interaction,
  graph,
  focusCore,
  auxiliary,
  tidy,
  layoutSurfaceEpoch,
}) {
  const {
    nodeDimensions,
    snapToGrid,
    setSnapToGrid,
    handleDimensionsChange,
    autoPositions,
    elkPositionsOk,
    measuredElkSettled,
    isAnimatingLayout,
    isAnimatedTidyToolbarSession,
    triggerLayout,
    clearCustomPositionsForNodeIds,
    canvasContextMenuState,
    canvasMenuRef,
    followTaskAfterLayout,
  } = base;

  const {
    containerRef,
    containerRectRef,
    selectedNodes,
    selectedEdge,
    setSelectedNodes,
    connectingFrom,
    connectingTarget,
    connectingBranch,
    connectingStartPos,
    reconnectingEdge,
    mousePos,
    draggingNode,
    pan,
    zoom,
    setPan,
    setPanAnimated,
    setPanUnconstrained,
    setZoom,
    isPanning,
    isDragging,
    isConnecting,
    isSelectingBox,
    selectionBox,
    contentBounds,
    constrainPan,
    dropTarget,
    pendingNestAction,
    cancelNestAction,
    confirmNestAction,
    handleCanvasMouseDown,
    handleMouseUp,
    handleContextMenu,
    handleNodeDragStart,
    handleNodeClick,
    handleConnectionDragStart,
    handleEdgeArrowDragStart,
    handleEdgeClick,
    handleCanvasClick,
    handleResetView,
    handleGoToStart,
    handleGoToStartInstant,
    handleZoomIn,
    handleZoomOut,
    deleteSelectedNodes,
    autoArrangeBlocked,
    isAnimatingPan,
  } = interaction;

  const { nodePositions, edges, lockStates, effectiveChainInfo } = graph;

  const {
    focusedTaskIds,
    allFocusedTaskIds,
    hiddenConnections,
    displayTasks,
    displayPositions,
    displayEdges,
    focusContentBounds,
    handleFocusTask,
    handleFocusTasks,
    handleExitFocusMode,
    isFocusMode,
    centerOnTask,
    panToPosition,
    isAnimatingIntoFocus,
    isAnimatingOutOfFocus,
    positionsToUse,
    getNodeAnimationState,
    focusSelectedTasks,
    focusTasksInstant,
    exitFocusModeInstant,
    handleConditionsDialogOpen,
    handleConditionsDialogClose,
  } = focusCore;

  const { handleAutoLayout, handleAutoLayoutInstant, isAnimatingTidy, isPartialTidyToolbarLoading } = tidy;

  const isTidyToolbarBusy = Boolean(isAnimatedTidyToolbarSession || isPartialTidyToolbarLoading);

  return {
    nodeDimensions,
    snapToGrid,
    setSnapToGrid,
    handleDimensionsChange,
    autoPositions,
    elkPositionsOk,
    measuredElkSettled,
    chainInfo: effectiveChainInfo,
    isAnimatingLayout,
    triggerLayout,
    nodePositions,
    edges,
    lockStates,
    interaction,
    containerRef,
    containerRectRef,
    selectedNodes,
    selectedEdge,
    setSelectedNodes,
    connectingFrom,
    connectingTarget,
    connectingBranch,
    connectingStartPos,
    reconnectingEdge,
    mousePos,
    draggingNode,
    pan,
    zoom,
    setPan,
    setPanAnimated,
    setPanUnconstrained,
    setZoom,
    isPanning,
    isDragging,
    isConnecting,
    isSelectingBox,
    selectionBox,
    contentBounds,
    constrainPan,
    dropTarget,
    pendingNestAction,
    cancelNestAction,
    confirmNestAction,
    handleCanvasMouseDown,
    handleMouseUp,
    handleContextMenu,
    handleNodeDragStart,
    handleNodeClick,
    handleConnectionDragStart,
    handleEdgeArrowDragStart,
    handleEdgeClick,
    handleCanvasClick,
    handleResetView,
    handleGoToStart,
    handleGoToStartInstant,
    handleZoomIn,
    handleZoomOut,
    deleteSelectedNodes,
    autoArrangeBlocked,
    focusedTaskIds,
    allFocusedTaskIds,
    hiddenConnections,
    displayTasks,
    displayPositions,
    displayEdges,
    focusContentBounds,
    handleFocusTask,
    handleFocusTasks,
    handleExitFocusMode,
    isFocusMode,
    centerOnTask,
    panToPosition,
    isAnimatingIntoFocus,
    isAnimatingOutOfFocus,
    positionsToUse,
    edgesToRender: auxiliary.virtualizedEdgesToRender,
    tasksToRender: auxiliary.virtualizedTasksToRender,
    fullNodeIds: auxiliary.fullNodeIds,
    getNodeAnimationState,
    focusSelectedTasks,
    focusTasksInstant,
    exitFocusModeInstant,
    virtualizationStats: auxiliary.virtualizationStats,
    getViewportCenter: auxiliary.getViewportCenter,
    findEmptySpaceInViewport: auxiliary.findEmptySpaceInViewport,
    findPositionInCampaign: auxiliary.findPositionInCampaign,
    isViewReady: auxiliary.isViewReady,
    handleAutoLayout,
    handleAutoLayoutInstant,
    isAnimatingTidy,
    isTidyToolbarBusy,
    isAnimatingPan,
    clearCustomPositionsForNodeIds,
    setTaskPosition: auxiliary.setTaskPosition,
    handleCreateConnectedNode: auxiliary.handleCreateConnectedNode,
    handleInsertNodeOnEdge: auxiliary.handleInsertNodeOnEdge,
    centerOnSelected: auxiliary.centerOnSelected,
    copyNode: auxiliary.copyNode,
    duplicateNode: auxiliary.duplicateNode,
    pasteConnectedToHost: auxiliary.pasteConnectedToHost,
    pasteBeforeHost: auxiliary.pasteBeforeHost,
    hasClipboardData: auxiliary.hasClipboardData,
    handleConditionsDialogOpen,
    handleConditionsDialogClose,
    canvasContextMenu: canvasContextMenuState,
    canvasMenuRef,
    closeCanvasContextMenu: auxiliary.closeCanvasContextMenu,
    handleAddMissionAtPosition: auxiliary.canvasContextMenu.handleAddMissionAtPosition,
    handleAddDecisionAtPosition: auxiliary.canvasContextMenu.handleAddDecisionAtPosition,
    handleAddWaitAtPosition: auxiliary.canvasContextMenu.handleAddWaitAtPosition,
    handlePasteAtPosition: auxiliary.canvasContextMenu.handlePasteAtPosition,
    hoveredNodeId: auxiliary.hoveredNodeId,
    campaignDrop: auxiliary.campaignDrop,
    layoutSurfaceEpoch,
    followTaskAfterLayout,
  };
}
